import accessRanking from "./en/accessRanking";
import bbtFooter from "./en/bbt/footer";
import bbtGlobalNav from "./en/bbt/globalNav";
import bbtHeader from "./en/bbt/header";
import breadcrumbs from "./en/breadcrumbs";
import bulletinboard from "./en/bulletinboard";
import common from "./en/common";
import contact from "./en/contact";
import event from "./en/event";
import footer from "./en/footer";
import globalNav from "./en/globalNav";
import interviews from "./en/interviews";
import introductionCorporate from "./en/introductionCorporate";
import news from "./en/news";
import preview from "./en/preview";
import register from "./en/register";
import related from "./en/related";
import report from "./en/report";
import sandbox from "./en/sandbox";
import search from "./en/search";
import snsShareButton from "./en/snsShareButton";
import supporters from "./en/supporters";
import top from "./en/top";
import pageNotFound from "./en/pageNotFound";
import header from "./en/header";
import recommend from "./en/recommend";
import support from "./en/support";

export default {
  hello: "Hello", // For testing
  ...common,
  ...footer,
  ...globalNav,
  ...breadcrumbs,
  ...bulletinboard,
  ...event,
  ...preview,
  ...accessRanking,
  ...register,
  ...related,
  ...search,
  ...introductionCorporate,
  ...contact,
  ...top,
  ...interviews,
  ...news,
  ...report,
  ...snsShareButton,
  ...supporters,
  ...sandbox,
  ...pageNotFound,
  ...header,
  ...recommend,
  ...support,
  // BBT
  ...bbtGlobalNav,
  ...bbtFooter,
  ...bbtHeader,
} as const;
